import React from 'react';
import BaseComponent from './BaseComponent';
import {connect} from 'react-redux';
import classNames from 'classnames';
import Octicon from 'react-octicon';

class PureEntry extends BaseComponent {
    render() {
        const {entry, event, venue, scratchEntry, unscratchEntry} = this.props;

        return <div className="entry">
            <h4>{entry.first_name} {entry.surname}</h4>
            <p>
                <strong>Venue:</strong> {venue.name}
                <br />
                <strong>Event:</strong> {entry.draw} in {event.name} - {event.start_time.format('ddd HH:mm')} (estimated performance at {entry.start_time.format('HH:mm')})
            </p>
            <p>
                {entry.scratched
                ?<button onClick={() => unscratchEntry(entry.id)} className="btn btn-danger">Scratched</button>
                :<button onClick={() => scratchEntry(entry.id)} className="btn btn-success">Not scratched</button>
                }
            </p>
            {/*}
            <pre>{JSON.stringify(entry, null, 4)}</pre>
            <pre>{JSON.stringify(event, null, 4)}</pre>
            <pre>{JSON.stringify(venue, null, 4)}</pre>
            {*/}
            <hr />
        </div>;
    }
}

const entryActions = {
    scratchEntry(id) {
        return (dispatch, getState) => {
            const user = getState().app.get('user');

            dispatch({type: 'scratchEntry', id});

            db
                .ref(`/schedule/entries/${id}/scratched`)
                .set(true)
                .catch(error => {
                    dispatch({type: 'unscratchEntry', id});
                })
            ;
        };
    },

    unscratchEntry(id) {
        return (dispatch, getState) => {
            const user = getState().app.get('user');

            dispatch({type: 'scratchEntry', id});

            db
                .ref(`/schedule/entries/${id}/scratched`)
                .set(false)
                .catch(error => {
                    dispatch({type: 'unscratchEntry', id});
                })
            ;
        };
    },
};

const Entry = connect(null, entryActions)(PureEntry);

export class PureAdmin extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            search: '',
        };
        this.updateSearch = this.updateSearch.bind(this);
    }

    updateSearch(e) {
        this.setState({search: e.target.value});
    }

    render() {
        const {search} = this.state;

        return <div className="admin row">
            <div className="col-md-12">
                <form className="form-inline">
                    <div className="form-group">
                        <label>Search:</label>
                        {' '}
                        <input autoFocus className="form-control" placeholder="search for name" value={search} onChange={this.updateSearch} />
                    </div>
                </form>
                <hr />
                {this.renderResults()}
            </div>
        </div>;
    }

    renderResults() {
        const {search} = this.state;
        const {entries, events, venues} = this.props;

        if (search.length < 3) {
            return;
        }

        const re = new RegExp(search, 'i');

        const matches = entries
            .toList()
            .filter(e => re.test(e.first_name + ' ' + e.surname))
            .sortBy(e => e.start_time)
        ;


        return <div className="entries">
            {matches.map(entry => {
                const event = events.get(entry.event);
                const venue = venues.get(event.venue);
                return <Entry key={entry.id} entry={entry} event={event} venue={venue} />;
            })}
        </div>
    }
}

function mapStateToProps({app}) {
    return {
        venues: app.get('venues'),
        events: app.get('events'),
        entries: app.get('entries'),
    };
}

const actions = {
};

export default connect(mapStateToProps, actions)(PureAdmin);



/** WEBPACK FOOTER **
 ** ./src/components/Admin.jsx
 **/